import { Sun } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgSun = mkIcon(Sun);